import React from 'react';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
import AboutFour from '../container/About/AboutFour';
import Video from '../container/Video/Video';
import AboutFive from '../container/About/AboutFive';
import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import data1 from '../data/content/aboutFourContent';
import data2 from '../data/content/aboutFiveContent';
import CallToActionThree from "../container/CallToAction/CallToActionThree";
import {useLocation} from "react-router-dom";
import data3 from "../data/SEO/seoData";

const NetworkServices = () => {
    const currentPage = useLocation();
    let seo_data = data3.filter(dataObj => dataObj.path === currentPage.pathname);
    return (
        <React.Fragment>
            <SEO title={seo_data[0].metaTitle} URL={seo_data[0].path} description={seo_data[0].metaDesc} />
            <Header />
            <Breadcrumb
                image={seo_data[0].bcEleImage}
                title={seo_data[0].bcEleTitle}
                content="Home"
                contentTwo="Network Services"
            />
            <AboutFour
                mainContent={data1.network.mainContent}
                subTitle={data1.network.subTitle}
                title={data1.network.title}
                backgroundImg={data1.network.backgroundImg} foregroundImg={data1.network.foregroundImg}
            />
            <Video content="Driving Business Growth with High-Performance Networks" />
            <AboutFive
                mainContent={data2.network.mainContent}
                subTitle={data2.network.subTitle}
                title={data2.network.title}
                backgroundImg={data2.network.backgroundImg} foregroundImg={data2.network.foregroundImg}
            />
            {/*<TestimonialContainer classOption="bg-primary-blue" />*/}
            <CallToActionThree titleContent="Future-Proof Your Network" />
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

export default NetworkServices;



